import React, {useEffect, useRef, useState} from "react";
import CatalogItem from "../CatalogItem";
import {columns, dataFields} from "./config";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {getStoreVTYTSearchKeyAPI} from "redux/reducer/medicalSupplies";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import ModalContent from "../ModalContent";
import {Spin, message} from "antd";
import {medicalSuppliesService} from "api";
import Notification from "components/common/notification/notification";
import {exportFile} from "helper/common";

const DanhMucVTYT = () => {
  const CATALOG_NAME = "Vật tư y tế";
  const TYPE_FORM = {
    THEM: "Thêm",
    SUA: "Sửa",
  };
  const modalRef = useRef<any>();
  const dispatch = useAppDispatch();
  const medicalSuppliesStore = useAppSelector(
    state => state.medicalSuppliesReducer
  );
  const [searchValue, setSearchValue] = useState();
  const [typeForm, setTypeForm] = useState("");
  const [catalogData, setCatalogData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState<any>({page: 1, limit: 10});
  const [dataFieldsForm, setDataFieldsForm] = useState(dataFields);

  useEffect(() => {
    dispatch(getStoreVTYTSearchKeyAPI(params));
  }, [params]);

  useEffect(() => {
    medicalSuppliesStore.quyCachList &&
      setOptionsSearchFields(medicalSuppliesStore.quyCachList, "quyCachId");
  }, [medicalSuppliesStore.quyCachList]);
  useEffect(() => {
    medicalSuppliesStore.suppliesGroupList &&
      setOptionsSearchFields(
        medicalSuppliesStore.suppliesGroupList,
        "nhomVTYTId"
      );
  }, [medicalSuppliesStore.suppliesGroupList]);
  useEffect(() => {
    medicalSuppliesStore.manufacturerList &&
      setOptionsSearchFields(
        medicalSuppliesStore.manufacturerList,
        "hangSanXuatId"
      );
  }, [medicalSuppliesStore.manufacturerList]);
  useEffect(() => {
    medicalSuppliesStore.manufacturedCountryList &&
      setOptionsSearchFields(
        medicalSuppliesStore.manufacturedCountryList,
        "nuocSanXuatId"
      );
  }, [medicalSuppliesStore.manufacturedCountryList]);
  useEffect(() => {
    medicalSuppliesStore.donViTinhList &&
      setOptionsSearchFields(medicalSuppliesStore.donViTinhList, "donViTinhId");
  }, [medicalSuppliesStore.donViTinhList]);
  useEffect(() => {
    medicalSuppliesStore.donViApList &&
      setOptionsSearchFields(medicalSuppliesStore.donViApList, "donViApKQDTId");
  }, [medicalSuppliesStore.donViApList]);

  const setOptionsSearchFields = (list, name) => {
    if (dataFieldsForm.find(field => field.name === name)) {
      dataFieldsForm.find(field => field.name === name).options = list?.map(
        item => ({
          value: item.id,
          label: item.name,
        })
      );
      setDataFieldsForm([...dataFieldsForm]);
    }
  };

  const handleModalCreat = () => {
    setTypeForm(TYPE_FORM.THEM);
    setCatalogData(null);
    modalRef.current?.openModal();
  };
  const handleModalEdit = recod => {
    setTypeForm(TYPE_FORM.SUA);
    setCatalogData(recod);
    modalRef.current?.openModal();
  };
  const handleRemove = async id => {
    setLoading(true);
    try {
      await medicalSuppliesService.deleteDanhMucVTYT(id);
      await dispatch(getStoreVTYTSearchKeyAPI(params));
      setLoading(false);
      Notification("success", `Xóa ${CATALOG_NAME} thành công`);
    } catch (error) {
      // console.log(error);
      setLoading(false);
      if (error?.response?.data.includes("sử dụng")) {
        Notification("error", error?.response?.data);
      } else
        Notification(
          "error",
          error?.response?.data ?? `Đã có lỗi khi xóa thông tin ${CATALOG_NAME}`
        );
    }
  };
  const onPagingChange = (page, pageSize) => {
    setParams({...params, page: page, limit: pageSize});
  };
  const handleSubmitForm = async value => {
    setLoading(true);
    try {
      if (typeForm === TYPE_FORM.THEM) {
        await medicalSuppliesService.postDanhMucVTYT(value);
      }
      if (typeForm === TYPE_FORM.SUA) {
        await medicalSuppliesService.putDanhMucVTYT(value);
      }
      await dispatch(getStoreVTYTSearchKeyAPI(params));
      setLoading(false);
      Notification("success", `${typeForm} ${CATALOG_NAME} thành công`);
      modalRef.current?.closeModal();
      setCatalogData(null);
    } catch (error) {
      setLoading(false);
      modalRef.current?.closeModal();

      if (error?.response?.data.includes("sử dụng")) {
        Notification("error", error?.response?.data);
      } else {
        Notification(
          "error",
          error?.response?.data ??
            `Đã có lỗi khi ${typeForm} thông tin ${CATALOG_NAME}`
        );
      }
    }
  };
  const getReport = async () => {
    const nameFile = `Báo cáo danh mục vật tư y tế`;
    exportFile("store/VTYT/export-danh-muc-vtyt", {}, nameFile);
  };
  const onSearch = value => {
    setParams({page: 1, limit: params.limit, tenTheoThuongMai: value});
  };
  const onChangeSearch = e => {};
  return (
    <>
      <Spin spinning={loading}>
        <CatalogItem
          nameCatalog={`Danh mục ${CATALOG_NAME}`}
          tableData={{
            columns,
            dataSource: medicalSuppliesStore.vTYTSearchKeyList,
            pagination: {
              onChange: onPagingChange,
              total: medicalSuppliesStore.vTYTSearchKeyTotal,
            },
            scroll: {x: 2000},
          }}
          isBtnEdit={true}
          onClickCreate={handleModalCreat}
          onClickEdit={data => handleModalEdit(data)}
          onClickRemove={id => handleRemove(id)}
          onClickReport={getReport}
          onSearch={onSearch}
          onChangeSearch={onChangeSearch}
        ></CatalogItem>
      </Spin>
      <ModalCustom
        ref={modalRef}
        width={1400}
        title={`${typeForm}  vật tư y tế`}
      >
        <ModalContent
          nameCatalog={CATALOG_NAME}
          data={catalogData}
          type={typeForm}
          dataFields={dataFieldsForm}
          onSubmitForm={handleSubmitForm}
          loading={loading}
        ></ModalContent>
      </ModalCustom>
    </>
  );
};

export default DanhMucVTYT;
